import React from 'react';
import LookupActions from '../actions/LookupActions';
import LookupRefreshStore from '../stores/LookupRefreshStore';
import FormResourceUtil from '../utils/FormResourceUtil';
import ServiceHelper from '../remote/ServiceHelper';
import CommandHelper from '../remote/CommandHelper';
import CommandResolver from '../utils/CommandResolver';
import StringUtil from '../utils/StringUtil';
import FormItemConst from '../formItem/FormItemConst';
import FormItemStringRenderForAutoLookup from '../formItem/renders/FormItemStringRenderForAutoLookup';

const ReactDataGrid = require('react-data-grid');

export default class FormLookupServerAllSpec extends React.Component
{

	constructor(props)
	{
		super(props);
		this.classAlias = "FormLookupServerAllSpec";
		this.entityId = this.props.entityId;
	  	this.innerId = this.props.innerId;
	  	this.groupAlias = this.props.groupAlias;
	  	this.fieldName = this.props.fieldName;
		this.unsubscribeLookupCmpStore = LookupRefreshStore.listen(this.onDataProviderRefresh.bind(this));	
		let gridColumns = this.props.remoteArg.columns;let columns = [];let totalWidth = 100;
		if(gridColumns)
		{
			totalWidth = 0;
			for(let i = 0;i<gridColumns.length;i++)
			{
				let column = {};column.editable = false;column.resizable = true;
				let gridColumn = gridColumns[i];
				column.key = gridColumn.dataField;
				column.key = StringUtil.convertToFirstLowerCase(column.key);
				let _width;
				if(column.width)
					_width = gridColumn.width;
				else
					_width = gridColumn.displayLength * FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon;
				column.formatter = <FormItemStringRenderForAutoLookup dataField={gridColumn.dataField}/>
				column.width = _width;
				totalWidth+=_width;
				column.name = gridColumn.label;
				columns.push(column);
			}
		}
		if(totalWidth<this.props.minWidth)
			totalWidth = this.props.minWidth;
		this._columns = columns;
		this.state = { rows:[], selectedIndexes: [0], scrollmax:0, gridContainerWidth:totalWidth};
	}

	onDataProviderRefresh(entityId,innerId)
	{
	  	if(this.entityId!=entityId || this.innerId != innerId)
	  		return;
	  	let fm = window.formModuleInstance;
		if(fm==null)
			return;
		let formId = fm.formId;let cmdargInfo;
		
		if(!this.groupAlias)
		{
			cmdargInfo = FormResourceUtil.getCommandArgMethodInfo("lookup_"+this.fieldName,window.menuItemId,window.formId);
			
		}
		else
		{
			cmdargInfo = FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+"."+"lookup_"+this.fieldName,window.menuItemId,window.formId);
		}
		
		if(cmdargInfo)
		{
			let baseRecord = this.lookupArg["baseRecord"];
			if(baseRecord && baseRecord.visualLength && typeof(baseRecord.visualLength) == "function")
				 delete baseRecord["visualLength"];
			//cmdargInfo.fetchOption = true;
			let arg = CommandResolver.getSendCmd(window.formModuleInstance, this.groupAlias, cmdargInfo);
			var command = CommandHelper.createFormInstance(window.formModuleInstance.formName, "doLookup").appendArg(arg, "CommandArg")
				.appendArg(this.lookupArg["groupAlias"], "String").appendArg(this.fieldName, "String")
				.appendArg(this.lookupArg["filterFieldName"], "String").appendArg(this.lookupArg["baseFilter"], "String")
				.appendArg(this.lookupArg["baseRecord"], "Object").appendArg(this.lookupArg["queryObject"], "Object")
				.appendArg("true", "boolean").appendArg("0", "int").appendArg("50", "int").appendArg("true", "boolean");
			let remoteArg = {command:command,resultFunction:this.rpc_result_refreshData.bind(this)};
			ServiceHelper.addTokenWithCommand(remoteArg);
		}
	}

	rpc_result_refreshData(data)
	{
		//TODO 按照Flex代码逻辑 有可能出现多层数据结构的情况 需要数据转换成单层
		var result = data.result;
		if(result)
		{
			this.setState({rows:result.dataResult?result.dataResult:[],selectedIndexes: [0]});
		}
	}

	rowGetter(i) 
	{
	    return this.state.rows[i];
	}

	rowClick(index,record,proxy)
	{
	  	if(this.props.remoteArg.returnFields && this.props.remoteArg.returnFields.length>0)
		{
			let datas = this.state.rows;
		  	let returnItem = datas[index];
			let castedReturnItem = this.castLookupReturnFields(this.props.remoteArg.returnFields,returnItem);
			LookupActions.lookupReturn(castedReturnItem,this.props.entityId,this.props.innerId);	
		}
	}

	castLookupReturnFields(arr,fromRecord)
	{
		for(let i = 0;i<arr.length;i++)
		{
			let flrf = arr[i];
			let _from = StringUtil.convertToEachFirstLowerCase(flrf.fromDataField);
			//let _from = flrf.fromDataField;
			let _fromObj;let fromValue;
			//TODO 按照Flex代码逻辑 有可能出现多层数据结构的情况 需要数据转换成单层
			if(fromRecord.hasOwnProperty(_from) || fromRecord.hasOwnProperty(flrf.fromDataField))
			{
				_fromObj = fromRecord[_from]?fromRecord[_from]:fromRecord[flrf.fromDataField];		
			}
			
			fromValue = _fromObj;
			flrf.fromValue = fromValue;
		}
		return arr;
	}

	gridKeyDown(proxy)
  	{
  	  	if(proxy!=null && proxy!=undefined && proxy.hasOwnProperty("nativeEvent"))
	    {
	      let ne = proxy["nativeEvent"];
	      if(ne.keyCode == 40 || ne.keyCode == 38)
	      {
	      	this.moveSelectVertical(ne.keyCode);	      	
	      }
	      else if(ne.keyCode == 13)
	      {
	    	var datas = this.state.rows;
	    	if(!datas || datas.length==0)
	    		return;
	    	var index = 0;
	    	if(this.state.selectedIndexes && this.state.selectedIndexes.length>0)
	    		index = this.state.selectedIndexes[this.state.selectedIndexes.length-1];
		  	var returnItem = datas[index];
		  	var returnValue = returnItem[this.returnField];
		  	LookupActions.lookupReturn(returnValue,this.props.entityId,this.props.innerId);
	      }
	    }
  	}

  moveSelectVertical(keyCode)
  {
  	if(keyCode == 40 || keyCode == 38)
  	{
        let record = null;
        var newSelectIndexes = this.state.selectedIndexes;
        if(newSelectIndexes.length == 0)
        {
          if(this.state.rows.length>0)
          {
            record = keyCode == 40?this.state.rows[0]:this.state.rows[this.state.rows.length-1];
            newSelectIndexes.push(0);
          }
        }
        else
        {
          let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
          let newIndex = keyCode==40?lastIndex+1:lastIndex-1;
          let total = this.state.rows.length;
          if(newIndex>=0&&newIndex<total)
          {
            record = this.state.rows[newIndex];
            newSelectIndexes = [newIndex];
          }
        }
        var selected = this.grid.state.selected;
        var colIndex = 0;
        if(selected)
        	colIndex = selected.idx;
        var rowIndex = (newSelectIndexes&&newSelectIndexes.length>0)?newSelectIndexes[0]:0;
        this.setState({selectedIndexes:newSelectIndexes});
    	
    	this.grid.doOnSelect({rowIndex:rowIndex,idx:colIndex,active:false});	
       	$(this.refs["datagridcontainer"+this.entityId+this.innerId]).find(".react-grid-Row.row-selected>.react-grid-Cell.row-selected")[colIndex].focus();
        console.log("rowIndex:"+rowIndex+"   newSelectIndexes"+JSON.stringify(newSelectIndexes));
        //this.grid.doOnSelect({idx:idx,rowIdx:rowIdx,active:false});

	}
  }

	 render() 
	 {
	     return (
		    <div className={'datagridcontainer'} style={{width:(this.state.gridContainerWidth+40)+'px',height:'210px',display:'flex'}}
		    	 ref={"datagridcontainer"+this.entityId+this.innerId} id={"datagridcontainerLookup"+this.entityId+this.innerId}> 
		      	<ReactDataGrid
					ref={ node => this.grid = node }
		        	onRowClick={this.rowClick.bind(this)}
		       		onGridKeyDown={this.gridKeyDown.bind(this)}
					numColumn={true}
					columns={this._columns}
					enableCellSelect={true}
					rowGetter={this.rowGetter.bind(this)}
					rowsCount={this.state.rows.length}
		        	rowHeight={FormItemConst.DATAGRID_ROW_HEIGHT}
		        	headerRowHeight={FormItemConst.DATAGRID_HEADER_HEIGHT}
					minHeight={200}
					rowSelection={{
		  				showCheckbox: false,
		  				enableShiftSelect: true,
		  				selectBy: {
		  				  indexes: this.state.selectedIndexes
		  				}
				  	}}
				/>
		    </div>
		  );
	  }
}


// WEBPACK FOOTER //
// ./src/components/FormLookupServerAllSpec.js